import React, { useEffect, useState } from "react";
import { useDropzone } from "react-dropzone";
import { AppColor, AppConstants } from "../../../../types/Constants";
import { Box, Typography } from "@mui/material";
import FileUpload from "../../../../components/FileUpload";
import FileUploadPreview from "../../../../components/FileUploadPreview";
import AppConfirmDialog from "../../../../components/AppConfirmDialog";
import { convertByteString } from "../../../../utils/utils";

interface AssetUploadProps {
    imageId?: string,
    handleDeleteAsset: (deleteAssetImage: boolean) => void,
    handleFileChange: (file: File | undefined) => void,
}

const AssetUpload: React.FC<AssetUploadProps> = ({ imageId, handleFileChange, handleDeleteAsset }) => {

    const [uploadedFileForScreen, setUploadedFileForScreen] = useState<File | undefined>(undefined);
    const [openFileSizeExceededMessage, setOpenFileSizeExceededMessage] = useState<boolean>(false);
    const [deleteAssetImage, setDeleteAssetImage] = useState(false);

    const dropzoneForScreen = useDropzone({
        accept: {
          'image/*': ['.jpeg', '.jpg', '.png'],
        },
        maxFiles: 1,
    });
    
    useEffect(() => {
        if (dropzoneForScreen.acceptedFiles && dropzoneForScreen.acceptedFiles.length >= 1) {
            // Check if image is too large
            if (dropzoneForScreen.acceptedFiles[0].size < AppConstants.MaxImageBytes) {
                setUploadedFileForScreen(dropzoneForScreen.acceptedFiles[0]);
                handleFileChange(dropzoneForScreen.acceptedFiles[0]);
                handleDeleteAsset(false);
            }
            else {
                setOpenFileSizeExceededMessage(true);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dropzoneForScreen.acceptedFiles]);

    const onDeleteUploadFileForScreen = () => {
        dropzoneForScreen.acceptedFiles.splice(0, 1);
        setUploadedFileForScreen(undefined);
        handleFileChange(undefined);
        handleDeleteAsset(true);
        setDeleteAssetImage(true);
    };

    return (
        <>
            <Box>
            <Typography variant="h6" color="grey" ml={3} mb={1}>Custom Asset</Typography>
            <FileUpload
                dropzone={dropzoneForScreen}
                readonly={false}
            />
            <Box sx={{ display: "flex", padding: 2, marginTop: 3, justifyContent: "flex-start", alignItems: "center" }}>
                <Box sx={{ marginLeft: 2 }}>
                <Typography sx={{ color: AppColor.subHeaderText }}>This will appear on the landing page.</Typography>
                </Box>
            </Box>
            {(uploadedFileForScreen || (!deleteAssetImage && imageId != undefined)) &&
                <Box sx={{ paddingX: 2 }}>
                <FileUploadPreview
                    file={uploadedFileForScreen}
                    imageId={imageId}
                    onDeleteUploadFile={() => onDeleteUploadFileForScreen()}
                />
                </Box>}
            </Box>
            <AppConfirmDialog
            open={openFileSizeExceededMessage}
            onConfirm={() => setOpenFileSizeExceededMessage(false)}
            confirmButtonTitle="OK"
            disableDenyButton={true}
            title={`The image is too large. Beacon images have a maximum filesize of ${convertByteString(AppConstants.MaxImageBytes)}. Please try resizing the image then uploading it again.`}
            dialogTitle="Problem attaching image to beacon"
            content=""
            />
        </>
    );
};

export default AssetUpload;